function fn_comp_boxes() {
    var $fn = $(".comp_boxes"),
        $elm_heading = $fn.find(".part_item_boxes .elm_item_heading i");

    if ($fn.length) {
        $elm_heading.each(function(){
            var $text = $(this).text().replace(" /","<br>/");
            $(this).html($text);
        });
    }
}